export default [
    {
        header: 'Bienestar Social',
        resource: 'Evaluaciones BBSS',
        action: 'menu',
    },
    /*
    {
        title: 'Evaluaciones',
        route: 'evaluacionesbbss',
        icon: 'CheckCircleIcon',
        action: 'menu',
        resource: 'Evaluaciones BBSS'
    },
    */
    {
        title: 'Evaluaciones',
        icon: 'CheckCircleIcon',
        children: [
            {
                title: 'AGV Campo',
                route: 'evaluacionesbbss',
                action: 'menu',
                resource: 'Evaluaciones BBSS'
            },
            {
                title: 'AGV Packing',
                route: 'agvpacking',
                action: 'menu',
                resource: 'Evaluaciones BBSS'
            },
            {
                title: 'Arena Verde',
                route: 'arenaverde',
                action: 'menu',
                resource: 'Evaluaciones BBSS'
            },
            {
                title: 'Campamento',
                route: 'campamento',
                action: 'menu',
                resource: 'Evaluaciones BBSS'
            },
        ],
    },
    {
        title: 'Eventos',
        route: 'eventosbbss',
        icon: 'fa-solid fa-gifts',
        action: 'menu',
        resource: 'Eventos BBSS'
    },
    {
        title: 'Absentismos',
        route: 'absentismosbbss',
        icon: 'fa-solid fa-hand-holding-medical',
        action: 'menu',
        resource: 'SA Absentismos'
    },
    {
        title: 'Asig. Familiares',
        route: 'asignacionesbbss',
        icon: 'fa-solid fa-people-roof',
        action: 'menu',
        resource: 'SA Asignaciones Familiares'
    },
    {
        title: 'BBSS Mant.',
        icon: 'fa-solid fa-database',
        children: [
            {
                title: 'Categorías',
                action: 'menu',
                resource: 'Evaluaciones BBSS',
                children:[
                    {
                        title: '- AGV',
                        route: 'categoriasagv',
                        action: 'menu',
                        resource: 'Evaluaciones BBSS'
                    },
                    {
                        title: '- ARV',
                        route: 'categoriasarv',
                        action: 'menu',
                        resource: 'Evaluaciones BBSS'
                    },
                    {
                        title: '- Packing',
                        route: 'categoriaspacking',
                        action: 'menu',
                        resource: 'Evaluaciones BBSS'
                    },
                    {
                        title: '- Campamento',
                        route: 'categoriascampamento',
                        action: 'menu',
                        resource: 'Evaluaciones BBSS'
                    },
                ]
            },
        ],
    },
]
